import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * FAB to redirect artists to the dashboard tab where they can create
 * rewards, challenges, etc. Hidden for non-artists.
 */
export const ArtistCreateFab = ({ tab, label = "Creer", testId, createFlag }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user || user.role !== "artist") return null;

  const url = createFlag
    ? `/dashboard?tab=${tab}&create=${createFlag}`
    : `/dashboard?tab=${tab}`;

  return (
    <button
      onClick={() => navigate(url)}
      className="fixed bottom-24 right-4 z-40 bg-gradient-to-r from-[#FF6B35] to-[#7000FF] text-white font-bold rounded-full shadow-2xl hover:scale-105 active:scale-95 transition-transform flex items-center gap-2 px-5 py-3.5"
      data-testid={testId || `create-fab-${tab}`}
      aria-label={label}
    >
      <Plus className="w-5 h-5" />
      <span className="text-sm">{label}</span>
    </button>
  );
};
